import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=f4ae7720&scoped=true"
import script from "./Publication.js?vue&type=script&lang=js&external"
export * from "./Publication.js?vue&type=script&lang=js&external"
import style0 from "./Publication.scss?vue&type=style&index=0&id=f4ae7720&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ae7720",
  null
  
)

export default component.exports